import { Link } from "react-router-dom";
import { useState } from "react";
import PlusMinusInput from "components/Form/PlusMinusInput/PlusMinusInput";
import useAPI from "hooks/useAPI";
import { currencyFormat } from "helpers/functions";
import DeleteDialog from "components/Dialogs/DeleteDielog";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import scss from "./CartTable.module.scss";

const ProductRow = ({ item, translateKey }) => {
    const { t } = useTranslation();
    const api = useAPI();
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const product = item?.product;
    const productId = product?.basic_data?.id_product ?? product?.id;
    const currency = product?.price?.currency;
    const rebate = product?.price?.per_item?.rebate;
    const discount = product?.price?.per_item?.discount;
    const rebateNames = rebate?.rebates?.map((entry) => entry?.calc?.calc_name).filter(Boolean).join("; ");

    const setQuantity = (quantity) => {
        api.globalAddToCart(productId, quantity, loading, setLoading, loadingDelete, setLoadingDelete, null, "replace");
    };

    const priceDetails = (
        <div className={scss.priceDetails}>
            <div>Regularna cena: {currencyFormat(product?.price?.per_item?.price_with_out_vat, currency)}</div>
            {rebate?.active && rebate?.rebates?.map((entry, index) => (
                <div key={`${entry?.calc?.calc_name}-${index}`}>Cena sa rabatom ({entry?.calc?.calc_name}): {currencyFormat(entry?.calc?.price, currency)}</div>
            ))}
            {discount?.active && discount?.campaigns?.map((campaign, index) => (
                <div key={`${campaign?.calc?.calc_name}-${index}`}>Cena sa popustom ({campaign?.calc?.calc_name}): {currencyFormat(campaign?.calc?.price, currency)}</div>
            ))}
        </div>
    );

    return (
        <>
            <tr aria-busy={loading || loadingDelete} className={loadingDelete ? scss.busyRow : undefined}>
                <td className={scss.tcCode}>{product?.basic_data?.sku}</td>
                <td className={scss.tcTitle}>
                    <Link to={`/katalog/artikal/${product?.id}`} className={scss.productName}>
                        {product?.basic_data?.name}
                    </Link>
                    {product?.basic_data?.attributes_text && <span className={scss.attributes}>{product.basic_data.attributes_text}</span>}
                </td>
                <td className={scss.money}>{currencyFormat(product?.price?.per_item?.price_with_out_vat, currency)}</td>
                <td>{rebate?.active && rebateNames ? rebateNames : "0"}</td>
                <td className={scss.money}>{discount?.active && Number(discount.amount) > 0 ? `-${currencyFormat(discount.amount, currency)}` : "0"}</td>
                <td className={scss.money}>
                    <Tooltip title={priceDetails} placement="top" arrow>
                        <span className={scss.priceHint}>{currencyFormat(product?.price?.per_item?.price_subtotal, currency)}</span>
                    </Tooltip>
                </td>
                <td className={scss.tcInt}>
                    <label className={scss.visuallyHidden} htmlFor={`${product?.id}_CartWeb`}>{t(`${translateKey}-table_th-quantity`)}</label>
                    <PlusMinusInput
                        behaviours={product?.behaviours?.cart}
                        max={Number(product?.inventory?.amount)}
                        quantity={Number(item?.cart?.quantity ?? 0)}
                        setQuantity={setQuantity}
                        debounceId={`${product?.id}_CartWeb`}
                        className={scss.quantityInput}
                    />
                </td>
                <td className={scss.money}>{currencyFormat(product?.price?.cost?.subtotal, currency)}</td>
                <td className={scss.tcActions}>
                    <button type="button" className={scss.removeButton} onClick={() => setShowDialog(true)} aria-label={`Izbriši ${product?.basic_data?.name}`} title="Izbriši">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l.7 12a1.5 1.5 0 0 0 1.5 1.4h6.6a1.5 1.5 0 0 0 1.5-1.4l.7-12M10 10.5v6M14 10.5v6" />
                        </svg>
                    </button>
                </td>
            </tr>
            <DeleteDialog
                title={`${translateKey}-delete_dialog-title`}
                description={`${translateKey}-delete_dialog-description`}
                openDeleteDialog={{ show: showDialog }}
                setOpenDeleteDialog={() => setShowDialog(false)}
                handleConfirm={() => {
                    setLoadingDelete(true);
                    setQuantity(0);
                    setShowDialog(false);
                }}
            />
        </>
    );
};

export default ProductRow;
